const UPDATE_UI         = 'kronos/ui/UPDATE_UI';

const initialState = {
    collapsedSideBar: false,
    isMobile: window.innerWidth <= 767 ? true : false,
    isTablet: window.innerWidth > 767 && window.innerWidth <= 1024 ? true : false,
    // Mobile: closed by default (hamburger opens it). Desktop/tablet: visible by default.
    showNav: window.innerWidth > 767 ? true : false,
    showChangelog: false,
    highlightChangelog: false,
    showHealthChecks: false,
    showSynchronisationPanel: false,
    isEmbedded: false
};

/* Export reducer */
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_UI:
            return {
                ...state,
                ...action.update
            };
        default:
            return state;
    };
};

/* Actions */
export function updateUi(update) {
    return (dispatch) => {
        dispatch({type : UPDATE_UI, update});
    }
}
